import * as React from 'react';
import styled from 'styled-components';
import * as fonts from 'view/styles/fonts';
import * as grid from 'view/styles/grid';
import * as mixins from 'view/styles/mixins';
import * as transitions from 'view/styles/transitions';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import type { LinkProps } from '@atlassian/help-center-common-component/analytics/link';
import { Link } from '@atlassian/help-center-common-component/analytics/link';

interface Props {
    elevated?: boolean;
}

const RESULT_HEIGHT = grid.unitless * 7;

// eslint-disable-next-line rulesdir/no-styled-export, rulesdir/styled-component-order
export const TitleContainer = styled.span`
    ${mixins.clamp};
`;

// eslint-disable-next-line rulesdir/no-styled-export, rulesdir/styled-component-order
export const Title = styled.h3`
    ${fonts.regular};
    ${mixins.clamp};
    margin: 0;
    font-weight: normal;
    transition: color ${transitions.speedMs.medium}ms ${transitions.timingFunctions.easeInOut};
`;

// eslint-disable-next-line rulesdir/no-styled-export,rulesdir/styled-component-order
export const SubTitle = styled.p`
    ${fonts.small};
    ${mixins.clamp};
    margin: 0;
    color: ${token('color.text.subtle', colors.N300)};
`;

const BaseLink: React.FunctionComponent<LinkProps & Props> = ({ elevated, ...props }) => <Link {...props} />;

// eslint-disable-next-line rulesdir/no-styled-export
export const Root = styled(BaseLink)`
    display: flex;
    ${mixins.borderRadius};
    ${(props) => mixins.applyIf(!!props.elevated, mixins.raiseUpOnHoverOrFocus())};
    height: ${RESULT_HEIGHT}px;
    background-color: ${(props) => (props.elevated ? token('elevation.surface.raised', colors.N0) : 'transparent')};
    transition: background-color ${transitions.speedMs.fast}ms ${transitions.timingFunctions.easeInOut},
        transform ${transitions.speedMs.fast}ms ${transitions.timingFunctions.easeInOut};
    position: relative;

    &:hover,
    &:focus {
        background-color: ${token('elevation.surface.raised', colors.N0)};
        text-decoration: none;
    }

    &:hover h3,
    &:focus h3 {
        color: ${(props) => token('color.link', props.theme.color)};
    }
`;
